export const navItems = [
  { label: "Обзор", icon: "grid", count: "" },
  { label: "Заказы", icon: "briefcase", count: "" },
  { label: "Клиенты", icon: "users", count: "" },
  { label: "Задачи мастеров", icon: "check", count: "" },
  { label: "Напоминания", icon: "bell", count: "4" },
  { label: "Отчёты", icon: "chart", count: "" },
] as const;
export const stages = [
  {
    name: "Новые",
    tone: "blue",
    amount: "₽ 1 240 000",
    deals: ["ЭкоТех", "Вектор Медиа", "СтройГарант"],
  },
  {
    name: "Квалификация",
    tone: "violet",
    amount: "₽ 860 000",
    deals: ["Альфа Сервис", "Фабрика 24"],
  },
  {
    name: "Переговоры",
    tone: "orange",
    amount: "₽ 2 180 000",
    deals: ["Норд Логистик", "Ритейл Плюс", "БиоФарм"],
  },
  { name: "Успешно", tone: "green", amount: "₽ 3 420 000", deals: ["Меридиан", "Горизонт"] },
] as const;
export const activities = [
  {
    initials: "АК",
    name: "Анна Крылова",
    action: "добавила заметку к клиенту",
    subject: "ЭкоТех",
    time: "10 минут назад",
    tone: "purple",
  },
  {
    initials: "ИС",
    name: "Илья Соколов",
    action: "перевёл сделку в этап",
    subject: "Переговоры",
    time: "32 минуты назад",
    tone: "orange",
  },
  {
    initials: "МВ",
    name: "Мария Власова",
    action: "закрыла задачу",
    subject: "Подготовить договор",
    time: "1 час назад",
    tone: "green",
  },
];
export const tasks = [
  {
    title: "Позвонить «Норд Логистик»",
    meta: "Сегодня, 14:30",
    owner: "ИС",
    priority: "Высокий",
    tone: "red",
  },
  {
    title: "Отправить коммерческое предложение",
    meta: "Сегодня, 16:00",
    owner: "АК",
    priority: "Средний",
    tone: "yellow",
  },
  {
    title: "Обновить карточку «Меридиан»",
    meta: "Завтра, 10:00",
    owner: "МВ",
    priority: "Низкий",
    tone: "gray",
  },
];

export const clients = [
  {
    name: "ЭкоТех",
    contact: "Ольга Миронова",
    industry: "Производство",
    status: "Активный",
    value: "₽ 680 000",
    initials: "ЭТ",
  },
  {
    name: "Норд Логистик",
    contact: "Дмитрий Волков",
    industry: "Логистика",
    status: "Переговоры",
    value: "₽ 1 200 000",
    initials: "НЛ",
  },
  {
    name: "Меридиан",
    contact: "Елена Соколова",
    industry: "Ритейл",
    status: "Активный",
    value: "₽ 920 000",
    initials: "М",
  },
  {
    name: "БиоФарм",
    contact: "Алексей Ким",
    industry: "Медицина",
    status: "Новый",
    value: "₽ 420 000",
    initials: "БФ",
  },
];

export const reminders = [
  {
    title: "Позвонить Дмитрию Волкову",
    context: "Норд Логистик · Переговоры",
    time: "Сегодня, 14:30",
    urgent: true,
  },
  {
    title: "Проверить договор с ЭкоТех",
    context: "ЭкоТех · Документы",
    time: "Сегодня, 17:00",
    urgent: false,
  },
  {
    title: "Отправить отчёт за неделю",
    context: "Внутренняя задача",
    time: "Завтра, 09:00",
    urgent: false,
  },
];

export const team = [
  { name: "Анна Крылова", role: "Администратор", deals: 14, conversion: "31%", initials: "АК" },
  { name: "Илья Соколов", role: "Менеджер", deals: 11, conversion: "26%", initials: "ИС" },
  { name: "Мария Власова", role: "Менеджер", deals: 11, conversion: "22%", initials: "МВ" },
];
